'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp; /**
                                   * Created by lyj on 2016/9/2.
                                   */

// import LoginComponent from '../Login/Login';

// import GoeasyInputField from '../GoeasyInputField/GoeasyInputField';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

var _reduxForm = require('redux-form');

var _loginValidation = require('../Login/loginValidation');

var _loginValidation2 = _interopRequireDefault(_loginValidation);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginModal = (_dec = (0, _reduxForm.reduxForm)({
  form: 'login',
  fields: ['name', 'password'],
  validate: _loginValidation2.default
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(LoginModal, _Component);

  function LoginModal() {
    (0, _classCallCheck3.default)(this, LoginModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LoginModal).call(this));

    _this.onHandleKeyDown = function (event) {
      var _this$props = _this.props;
      var _this$props$fields = _this$props.fields;
      var name = _this$props$fields.name;
      var password = _this$props$fields.password;
      var handleSubmit = _this$props.handleSubmit;
      // console.log(event);
      // console.log(event.keyCode);

      if (!!name && !!password && event.keyCode === 13) {
        handleSubmit();
      }
    };

    _this.state = {
      closeHover: true
    };
    return _this;
  }

  /*
   componentDidMount() {
   window.addEventListener('keydown', this.onHandleKeyDown, false);
   }
    componentWillUnmount() {
   window.removeEventListener('keydown', this.onHandleKeyDown, false);
   }
   */

  (0, _createClass3.default)(LoginModal, [{
    key: 'onClose',
    value: function onClose() {
      var closeModalFunc = this.props.closeModalFunc;

      if (closeModalFunc) {
        closeModalFunc();
      }
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }

    /*
     handleKeyDown(event) {
     const { handleSubmit } = this.props;
     if (handleSubmit) {
     if (event.keyCode === 13) {
     handleSubmit();
     }
     }
     }
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var _props$fields = _props.fields;
      var name = _props$fields.name;
      var password = _props$fields.password;
      var isOpened = _props.isOpened;
      var handleSubmit = _props.handleSubmit;
      var registerUrl = _props.registerUrl;
      var forgetPwdUrl = _props.forgetPwdUrl;
      var loginValid = _props.loginValid;
      var loginErrorMsg = _props.loginErrorMsg;

      var customStyle = {
        content: {
          background: 'none',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '4px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '20rem',
          width: '741px',
          maxWidth: '60rem'
        }
      };
      var styles = require('./LoginModal.scss');
      var closeHover = this.state.closeHover;

      var hoverClassName = styles.close + ' ' + styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.close + ' ' + styles.zhuan;
      }
      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit, className: styles.login, onKeyDown: function onKeyDown(event) {
              return _this2.onHandleKeyDown(event);
            } },
          _react2.default.createElement(
            'div',
            { className: styles.loginPic },
            _react2.default.createElement(
              'div',
              { className: styles.loginSecondPic },
              _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/lonlogo.png',
                alt: '' })
            ),
            _react2.default.createElement(
              'div',
              { className: styles.lgBack },
              _react2.default.createElement(
                'div',
                { className: styles.title },
                '服务条款'
              ),
              _react2.default.createElement('div', { className: styles.link }),
              _react2.default.createElement(
                'div',
                { className: styles.eng },
                _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/eng.png', alt: '' })
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'h3',
                null,
                '1、用户同意：'
              ),
              _react2.default.createElement(
                'span',
                null,
                '(1) 提供及时、详尽及准确的个人资料。'
              ),
              _react2.default.createElement(
                'span',
                null,
                '(2) 不断更新注册资料、符合及时、详尽、准确的要求。'
              ),
              _react2.default.createElement(
                'span',
                null,
                '如果用户提供的资料不准确，本网站有结束服务的权利。'
              ),
              _react2.default.createElement(
                'span',
                null,
                '(3) 不干扰或混乱网络服务。'
              ),
              _react2.default.createElement(
                'span',
                null,
                '(4) 遵守所有使用服务的网络协议、规定、程序和惯例。用户的行为准则是以因特网法规，政策、程序和惯例为根据的。'
              )
            )
          ),
          _react2.default.createElement(
            'span',
            { onMouseOver: this.closeImgMouseOver.bind(this), onMouseLeave: this.closeImgMouseLeave.bind(this),
              onClick: this.onClose.bind(this),
              className: hoverClassName },
            _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
              width: '100%' })
          ),
          _react2.default.createElement(
            'div',
            { className: styles.loginMes },
            _react2.default.createElement(
              'div',
              { className: styles.loginH1 },
              '登录'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.loginInput },
              _react2.default.createElement(
                'div',
                { className: styles.loginName },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'login-name-inp', className: styles.loginNameLabel },
                  '登录名：'
                ),
                _react2.default.createElement('input', (0, _extends3.default)({ type: 'text', className: styles.loginNameInp }, name, { id: 'login-name-inp',
                  placeholder: '请输入登录名/手机' })),
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/icon1.png', alt: '' })
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { className: styles.loginName, style: { paddingLeft: '12px', marginBottom: '34px' } },
                _react2.default.createElement(
                  'label',
                  { htmlFor: 'mm', className: styles.loginNameLabel },
                  '密码：'
                ),
                _react2.default.createElement('input', (0, _extends3.default)({ type: 'password', className: styles.loginNameInp }, password, {
                  id: 'mm' // onKeyDown={this.handleKeyDown.bind(this)}
                  , placeholder: '请输入密码' })),
                _react2.default.createElement(
                  'i',
                  null,
                  _react2.default.createElement('img', { src: 'http://tupian.goeasy.cn:9999/yipinwang/third/icon2.png', alt: '' })
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              loginValid === false ? _react2.default.createElement(
                'div',
                { className: styles.error },
                loginErrorMsg
              ) : '',
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { className: styles.loginName },
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: styles.linkBtn, target: '_blank', to: registerUrl },
                  '新用户注册'
                ),
                _react2.default.createElement(
                  _reactRouter.Link,
                  { className: styles.linkBtn + ' ' + styles.forgetBtn, target: '_blank', to: forgetPwdUrl },
                  '忘记密码?'
                )
              ),
              _react2.default.createElement('div', { className: 'clear' }),
              _react2.default.createElement(
                'div',
                { className: styles.loginName },
                _react2.default.createElement(
                  'span',
                  { className: styles.loginBtn, onClick: handleSubmit },
                  '立即登录'
                )
              )
            )
          )
        )
      );
    }
  }]);
  return LoginModal;
}(_react.Component), _class2.propTypes = {
  isOpened: _react.PropTypes.bool,
  onSubmit: _react.PropTypes.func,

  active: _react.PropTypes.string,
  asyncValidating: _react.PropTypes.bool.isRequired,
  fields: _react.PropTypes.object.isRequired,
  dirty: _react.PropTypes.bool.isRequired,
  resetForm: _react.PropTypes.func.isRequired,
  invalid: _react.PropTypes.bool.isRequired,
  pristine: _react.PropTypes.bool.isRequired,
  valid: _react.PropTypes.bool.isRequired,
  handleSubmit: _react.PropTypes.func,
  registerUrl: _react.PropTypes.string,
  hideCloseModalBtn: _react.PropTypes.bool,
  forgetPwdUrl: _react.PropTypes.string,

  closeModalFunc: _react.PropTypes.func,
  loginValid: _react.PropTypes.bool,
  loginErrorMsg: _react.PropTypes.string
}, _temp)) || _class);
exports.default = LoginModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/LoginModal/LoginModal.js
 ** module id = 1369
 ** module chunks = 0
 **/